<template>
    <v-container>
      <span class="bg"></span>
    				     <v-col cols="12" class="mt-n7 mb-15 px-3" align="center">
      <v-btn-toggle dark tile>
        <v-btn elevation="0" tile min-width="130px" :ripple="false" color="#202025" style="opacity: 0.8; border: none;" to="/documentation/intro">Intro</v-btn>
        <v-btn elevation="0" tile min-width="130px" :ripple="false" color="#202025" style="opacity: 0.8; border: none;" to="/documentation/commands">Commands</v-btn>
	  </v-btn-toggle>
          <v-btn-toggle dark tile>
        <v-btn elevation="0" tile min-width="130px" :ripple="false" color="#202025" style="opacity: 0.8; border: none;" to="/documentation/advanced">Advanced</v-btn>
        <v-btn elevation="0" tile min-width="130px" :ripple="false" color="red lighten-1" style="opacity: 1; border: none;" to="/documentation/reference">Reference</v-btn>
	  </v-btn-toggle>
	  <v-btn-toggle dark tile>
        <v-btn elevation="0" tile min-width="130px" :ripple="false" color="#202025" style="opacity: 0.8; border: none;" to="/documentation/guides">Guides</v-btn>
        <v-btn elevation="0" tile min-width="130px" :ripple="false" color="#202025" style="opacity: 0.8; border: none;" to="/documentation/api">API</v-btn>
	  </v-btn-toggle>
	  
    </v-col>
  <v-card height="100%" color="primary" class="mt-n8 mx-3">
    <v-card-text style="color: white;">

          <h1 class="mb-5 mt-2" id="timestamps">Discord Timestamps <v-btn elevation="0" class="mx-n2" :ripple="false" x-small text plain @click="copyText('https://raid-helper.dev/documentation/reference#timestamps')"><v-icon small color="grey" class="mb-1">mdi-link-variant</v-icon></v-btn></h1>
  <span>Discord timestamps allow you to create localized timestamps via <a style="text-decoration: none; color: #009ddb;" href="https://discord.com/developers/docs/reference#message-formatting" target="_blank">message formatting</a>.<br>You can create timestamps with this tool and click a row to copy the markdown and then paste it into a discord channel.
  </span><br>
  <v-col align="center">
  <v-hover v-slot="{ hover }"><div class="mt-2 px-2" style="background-color: #313338; display: inline-block; height: 36px; border-radius: 3px; cursor: pointer; padding-top: 6px;" :style="hover && $vuetify.breakpoint.xs ? 'background-color: #373a40; font-size: 0.7em;' : hover ? 'background-color: #373a40;' : $vuetify.breakpoint.xs ? 'font-size: 0.7em;' : ''" @click="overlay = true; overlayShadow = false;"><div><v-icon color="white">mdi-calendar</v-icon> {{getDate()}} <v-icon class="ml-1 mt-n1" color="white">mdi-clock-outline</v-icon> {{ getTime() }}</div></div></v-hover><br>

  </v-col>
    <v-simple-table v-if="date" class="mt-1" dark style="background-color: #18191c; color: darkgrey; border: 1px solid black; border-radius: 3px;">
    <template>
      <tbody>
        <tr style="background-color: #1e1f22; color: white;"><td style="height: 35px !important; color: white;"> INPUT </td><td style="height: 35px !important;">RESULT</td></tr>
        <tr style="background-color: #121315; cursor: pointer;" @click="copyText('<t:' + getUnix() + ':t>')"><td><span>&#60;t:{{getUnix()}}:t&#62;</span></td><td><v-tooltip transition="v-scale-transition" color="#0f0f0f" top><template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on" style="background-color: #ffffff14; padding: 2px; border-radius: 3px;">{{new Date(date.replace(/-/g, "/")).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}}</span></template><span>{{getDate() + " " + getTime()}}</span></v-tooltip></td></tr>
        <tr style="background-color: #18191c; cursor: pointer;" @click="copyText('<t:' + getUnix() + ':d>')"><td><span>&#60;t:{{getUnix()}}:d&#62;</span></td><td><v-tooltip transition="v-scale-transition" color="#0f0f0f" top><template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on" style="background-color: #ffffff14; padding: 2px; border-radius: 3px;">{{new Date(date.replace(/-/g, "/")).toLocaleDateString()}}</span></template><span>{{getDate() + " " + getTime()}}</span></v-tooltip></td></tr>
        <tr style="background-color: #121315; cursor: pointer;" @click="copyText('<t:' + getUnix() + ':D>')"><td><span>&#60;t:{{getUnix()}}:D&#62;</span></td><td><v-tooltip transition="v-scale-transition" color="#0f0f0f" top><template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on" style="background-color: #ffffff14; padding: 2px; border-radius: 3px;">{{new Date(date.replace(/-/g, "/")).toLocaleDateString([],{ year: 'numeric', month: 'long', day: 'numeric' })}}</span></template><span>{{getDate() + " " + getTime()}}</span></v-tooltip></td></tr>
        <tr style="background-color: #18191c; cursor: pointer;" @click="copyText('<t:' + getUnix() + ':f>')"><td><span>&#60;t:{{getUnix()}}:f&#62;</span></td><td><v-tooltip transition="v-scale-transition" color="#0f0f0f" top><template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on" style="background-color: #ffffff14; padding: 2px; border-radius: 3px;">{{new Date(date.replace(/-/g, "/")).toLocaleDateString([],{ year: 'numeric', month: 'long', day: 'numeric'}) + " " + getTime()}}</span></template><span>{{getDate() + " " + getTime()}}</span></v-tooltip></td></tr>
        <tr style="background-color: #121315; cursor: pointer;" @click="copyText('<t:' + getUnix() + ':F>')"><td><span>&#60;t:{{getUnix()}}:F&#62;</span></td><td><v-tooltip transition="v-scale-transition" color="#0f0f0f" top><template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on" style="background-color: #ffffff14; padding: 2px; border-radius: 3px;">{{new Date(date.replace(/-/g, "/")).toLocaleDateString([],{ weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}) + " " + getTime()}}</span></template><span>{{getDate() + " " + getTime()}}</span></v-tooltip></td></tr>
        <tr style="background-color: #18191c; cursor: pointer;" @click="copyText('<t:' + getUnix() + ':R>')"><td><span>&#60;t:{{getUnix()}}:R&#62;</span></td><td><v-tooltip transition="v-scale-transition" color="#0f0f0f" top><template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on" style="background-color: #ffffff14; padding: 2px; border-radius: 3px;"><i>Countdown</i></span></template><span>{{getDate() + " " + getTime()}}</span></v-tooltip></td></tr>
      </tbody>
    </template>
  </v-simple-table>

    <h1 class="mb-5 mt-10" id="markdown">Markdown <v-btn elevation="0" class="mx-n2" :ripple="false" x-small text plain @click="copyText('https://raid-helper.dev/documentation/reference#markdown')"><v-icon small color="grey" class="mb-1">mdi-link-variant</v-icon></v-btn></h1>
  <span>You can use <a style="text-decoration: none; color: #009ddb;" href="https://support.discord.com/hc/en-us/articles/210298617" target="_blank">discord markdown</a> in event descriptions and announcements:
  </span>
  
  <v-simple-table class="mt-5" dark style="background-color: #18191c; color: darkgrey; border: 1px solid black; border-radius: 3px;">
    <template>
      <tbody>
        <tr style="background-color: #1e1f22; color: white;"><td style="height: 35px !important; color: white;"> INPUT </td><td style="height: 35px !important;">DESCRIPTION</td></tr>
        <tr style="background-color: #121315;"><td>**text**</td><td>Display text in <b>bold</b> letters.</td></tr>
        <tr style="background-color: #18191c"><td>__text__</td><td><u>Underline</u> text.</td></tr>
        <tr style="background-color: #121315;"><td>_text_</td><td>Display text in <i>italic</i> letters.</td></tr>
        <tr style="background-color: #18191c"><td>~~text~~</td><td><strike>Cross out</strike> text.</td></tr>
        <tr style="background-color: #121315;"><td>[text](url)</td><td><a style="text-decoration: none; color: #009ddb;" href=''>Conceal a link.</a></td></tr>
   </tbody>
    </template>
  </v-simple-table>

  <h1 class="mb-5 mt-10" id="shortcodes">Shortcodes <v-btn elevation="0" class="mx-n2" :ripple="false" x-small text plain @click="copyText('https://raid-helper.dev/documentation/reference#shortcodes')"><v-icon small color="grey" class="mb-1">mdi-link-variant</v-icon></v-btn></h1>
  <span>There is a number of shortcodes that you can use inside an events title, description or announcement message.<br>That way you can create mentions of channels/roles and more:
  </span>
  

    <v-simple-table class="mt-5 mb-5" dark style="background-color: #18191c; color: darkgrey; border: 1px solid black; border-radius: 3px;">
    <template>
      <tbody>
        <tr style="background-color: #1e1f22; color: white;"><td style="height: 35px !important; color: white;"> INPUT </td><td style="height: 35px !important;">DESCRIPTION</td></tr>
        <tr style="background-color: #121315;"><td>{<i>ROLE NAME</i>}</td><td>Converts a role name into a mention.</td></tr>
        <tr style="background-color: #18191c;"><td>{<i>CHANNEL NAME</i>}</td><td>Converts a channel name into a mention.</td></tr>
        <tr style="background-color: #121315"><td>{id}</td><td>Converts into the events id.</td></tr>
        <tr style="background-color: #18191c"><td>{title}</td><td>Converts into the events title.</td></tr>
        <tr style="background-color: #121315"><td>{leader}</td><td>Converts into the event leaders mention.</td></tr>
        <tr style="background-color: #18191c"><td>{leadername}</td><td>Converts into the event leaders name.</td></tr>
        <tr style="background-color: #121315;"><td>{link}</td><td>Converts into the events url.</td></tr>
        <tr style="background-color: #18191c"><td>{softres}</td><td>Converts into the events softres url, if a softres is connected to the event.</td></tr>
        <tr style="background-color: #121315;"><td>{eventtime}</td><td>Converts into the events starting time discord timestamp. Result: <span style="background-color: #ffffff14; padding: 2px; border-radius: 3px;">Tuesday, 20 April 2021 16:20</span></td></tr>
        <tr style="background-color: #18191c;"><td style="vertical-align: top; padding-top: 17px;">{eventtime#unix}</td><td style="padding-top: 7px; padding-bottom: 7px;">Converts into the events starting time unix timestamp. Result: 1650806780<br>The unix timestamp can also be used to create <v-btn elevation="0" x-small plain :ripple="false" style="margin-top: -1px; margin-left: -7px; padding-left: -23px; font-size: 12px;" color="blue"  @click="openDiscordTimestamps = !openDiscordTimestamps">Discord timestamps<v-icon v-if="openDiscordTimestamps" size="small">mdi-chevron-up</v-icon><v-icon v-else size="small">mdi-chevron-down</v-icon></v-btn>
          <v-simple-table v-if="openDiscordTimestamps" dark style="background-color: #18191c; color: darkgrey; border: 1px solid black; margin-top: 10px; margin-bottom: 10px;">
    <template>
      <tbody>
        <tr style="background-color: #1e1f22; color: white;"><td style="height: 35px !important; color: white;"> INPUT </td><td style="height: 35px !important;">RESULT</td></tr>
        <tr style="background-color: #121315;"><td style="height: 35px !important;"> &lt;t:{eventtime#unix}:t&gt; </td><td style="height: 35px !important;"><span style="background-color: #ffffff14; padding: 2px; border-radius: 3px;">16:20</span></td></tr>
        <tr style="background-color: #18191c;"><td style="height: 35px !important;"> &lt;t:{eventtime#unix}:T&gt; </td><td style="height: 35px !important;"><span style="background-color: #ffffff14; padding: 2px; border-radius: 3px;">16:20:30</span></td></tr>
        <tr style="background-color: #121315;"><td style="height: 35px !important;"> &lt;t:{eventtime#unix}:d&gt; </td><td style="height: 35px !important;"><span style="background-color: #ffffff14; padding: 2px; border-radius: 3px;">20/04/2021</span></td></tr>
        <tr style="background-color: #18191c;"><td style="height: 35px !important;"> &lt;t:{eventtime#unix}:D&gt; </td><td style="height: 35px !important;"><span style="background-color: #ffffff14; padding: 2px; border-radius: 3px;">20 April 2021</span></td></tr>
        <tr style="background-color: #121315;"><td style="height: 35px !important;"> &lt;t:{eventtime#unix}:f*&gt; </td><td style="height: 35px !important;"><span style="background-color: #ffffff14; padding: 2px; border-radius: 3px;">20 April 2021 16:20</span></td></tr>
        <tr style="background-color: #18191c;"><td style="height: 35px !important;"> &lt;t:{eventtime#unix}:F&gt; </td><td style="height: 35px !important;"><span style="background-color: #ffffff14; padding: 2px; border-radius: 3px;">Tuesday, 20 April 2021 16:20</span></td></tr>
        <tr style="background-color: #121315;"><td style="height: 35px !important;"> &lt;t:{eventtime#unix}:R&gt; </td><td style="height: 35px !important;"><span style="background-color: #ffffff14; padding: 2px; border-radius: 3px;">3 years ago</span></td></tr>
  </tbody>
    </template>
  </v-simple-table>
        </td></tr>
        <tr style="background-color: #121315;"><td style="vertical-align: top; padding-top: 17px;">{eventtime#<i>FORMAT</i>}</td><td style="padding-top: 7px; padding-bottom: 7px;">Converts into the events starting time with the provided format.<br>The format is customizeable, here is a list of <v-btn elevation="0" x-small plain :ripple="false" style="margin-top: -1px; margin-left: -7px; padding-left: -23px; font-size: 12px;" color="blue"  @click="openFormatList = !openFormatList">examples and valid format characters<v-icon v-if="openFormatList" size="small">mdi-chevron-up</v-icon><v-icon v-else size="small">mdi-chevron-down</v-icon></v-btn>
  <v-simple-table v-if="openFormatList" dark style="background-color: #18191c; color: darkgrey; border: 1px solid black; margin-top: 10px; margin-bottom: 10px;">
    <template>
      <tbody>
        <tr style="background-color: #1e1f22; color: white;"><td style="height: 35px !important; color: white;"> INPUT </td><td style="height: 35px !important;">RESULT</td></tr>
        <tr style="background-color: #121315;"><td style="height: 35px !important;"> {eventtime#dd/MM} </td><td style="height: 35px !important;">20/04</td></tr>
        <tr style="background-color: #18191c;"><td style="height: 35px !important;"> {eventtime#HH:mm} </td><td style="height: 35px !important;">06:05</td></tr>
        <tr style="background-color: #121315;"><td style="height: 35px !important;"> {eventtime#EEEE, dd. MMMM} </td><td style="height: 35px !important;">Saturday, 20. April</td></tr>
  </tbody>
  
    </template>
  </v-simple-table>

    <v-simple-table v-if="openFormatList" dark style="background-color: #18191c; color: darkgrey; border: 1px solid black; margin-top: 10px; margin-bottom: 10px;">
    <template>
      <tbody>
        <tr style="background-color: #1e1f22; color: white;"><td style="height: 35px !important; color: white;"> SYMBOL </td><td style="height: 35px !important; color: white;">MEANING</td><td style="height: 35px !important;">EXAMPLES</td></tr>
        <tr style="background-color: #121315;"><td style="height: 35px !important;"> G; GGGG </td><td style="height: 35px !important;">era</td><td style="height: 35px !important;">AD; Anno Domini</td></tr>
        <tr style="background-color: #18191c;"><td style="height: 35px !important;"> yy; yyyy </td><td style="height: 35px !important;"> year-of-era </td><td style="height: 35px !important;">24; 2025</td></tr>
        <tr style="background-color: #121315;"><td style="height: 35px !important;"> MM; MMMM </td><td style="height: 35px !important;"> month-of-year </td><td style="height: 35px !important;">04; April</td></tr>
        <tr style="background-color: #18191c;"><td style="height: 35px !important;"> d; dd </td><td style="height: 35px !important;"> day-of-month </td><td style="height: 35px !important;">20</td></tr>
        <tr style="background-color: #121315;"><td style="height: 35px !important;"> E; EEEE </td><td style="height: 35px !important;"> day-of-week </td><td style="height: 35px !important;">Sat; Saturday</td></tr>
        <tr style="background-color: #18191c;"><td style="height: 35px !important;"> a </td><td style="height: 35px !important;"> am-pm-of-day </td><td style="height: 35px !important;">AM</td></tr>
        <tr style="background-color: #121315;"><td style="height: 35px !important;"> h; hh </td><td style="height: 35px !important;"> hour-of-am-pm (1-12) </td><td style="height: 35px !important;">6; 06</td></tr>
        <tr style="background-color: #18191c;"><td style="height: 35px !important;"> H; HH </td><td style="height: 35px !important;"> hour-of-day (0-23) </td><td style="height: 35px !important;">6; 06</td></tr>
        <tr style="background-color: #121315;"><td style="height: 35px !important;"> m; mm </td><td style="height: 35px !important;"> minute-of-hour </td><td style="height: 35px !important;">5; 05</td></tr>
        <tr style="background-color: #18191c;"><td style="height: 35px !important;"> w </td><td style="height: 35px !important;"> week-of-week-based-year </td><td style="height: 35px !important;">16</td></tr>
        <tr style="background-color: #121315;"><td style="height: 35px !important;"> W </td><td style="height: 35px !important;"> week-of-month </td><td style="height: 35px !important;">3</td></tr>

  </tbody>
  
    </template>
  </v-simple-table>
        </td></tr>
      </tbody>
    </template>
  </v-simple-table>


    <span class="ml-1">The above shortcodes support simple arithmetic operations. You can add and subtract minutes from the timestamps:
  </span>

    <v-simple-table class="mt-5 mb-5" dark style="background-color: #18191c; color: darkgrey; border: 1px solid black; border-radius: 3px;">

    <template>
      <tbody>
        <tr style="background-color: #1e1f22; color: white;"><td style="height: 35px !important; color: white;"> INPUT </td><td style="height: 35px !important;">DESCRIPTION</td></tr>

        <tr style="background-color: #121315;"><td>{eventtime+60}</td><td>Adds 60 minutes to the events starting time. Result: <span style="background-color: #ffffff14; padding: 2px; border-radius: 3px;">Tuesday, 20 April 2021 17:20</span></td></tr>
        <tr style="background-color: #18191c;"><td>{eventtime-60#unix}</td><td>Subtracts 60 minutes from the events starting time. Result: 1650810380</td></tr>
 </tbody>
    </template>
  </v-simple-table>

    <span class="ml-1">You can also use the keyword duration and deadline to dynamically add or subtract those values:
  </span>

    <v-simple-table class="mt-5 mb-5" dark style="background-color: #18191c; color: darkgrey; border: 1px solid black; border-radius: 3px;">

    <template>
      <tbody>
        <tr style="background-color: #1e1f22; color: white;"><td style="height: 35px !important; color: white;"> INPUT </td><td style="height: 35px !important;">DESCRIPTION</td></tr>
        <tr style="background-color: #121315;"><td>{eventtime+duration#HH:mm}</td><td>Adds the event duration to the events starting time. Result: 13:05</td></tr>
        <tr style="background-color: #18191c;"><td>{eventtime-deadline#hh:mm a}</td><td>Subtracts 60 minutes from the events starting time unix timestamp. Result: 10:05 PM</td></tr>
 </tbody>
    </template>
  </v-simple-table>
  
      <div class="ml-1">You can use the following shortcode to increment a number up or down on recurring events. This works in the event title, description and announcement messages. Each time the recurring event posts, it will add or subtract the provided number:
  </div>

    <v-simple-table class="mt-5" dark style="background-color: #18191c; color: darkgrey; border: 1px solid black; border-radius: 3px;">

    <template>
      <tbody>
        <tr style="background-color: #1e1f22; color: white;"><td style="height: 35px !important; color: white;"> INPUT </td><td style="height: 35px !important;">DESCRIPTION</td></tr>
        <tr style="background-color: #121315;"><td>{<i>number</i>+<i>number</i>}</td><td>The second number will be added to the first. Example: {0+1} Result: 1, 2, 3 etc.</td></tr>
        <tr style="background-color: #18191c;"><td>{<i>number</i>-<i>number</i>}</td><td>The second number will be subtracted from the first. Example: {100-1} Result: 99, 98, 97 etc.</td></tr>
 </tbody>
    </template>
  </v-simple-table>

    <h1 class="mb-5 mt-10" id="ids">Discord IDs <v-btn elevation="0" class="mx-n2" :ripple="false" x-small text plain @click="copyText('https://raid-helper.dev/documentation/reference#ids')"><v-icon small color="grey" class="mb-1">mdi-link-variant</v-icon></v-btn></h1>
  <span>Discord objects like servers, members, channels, messages and threads have unique ids assigned to them. The ID of a Raid-Helper event for example is simply the message ID. You might happen to need the ID of an object. This is usually done by right-clicking the object and choosing 'Copy ID'. If you don't see that option, you need to enable 'Developer mode' in your discord user settings under 'Advanced'.
  </span>

    <h1 class="mb-5 mt-10" id="unsigned">Unsigned <v-btn elevation="0" class="mx-n2" :ripple="false" x-small text plain @click="copyText('https://raid-helper.dev/documentation/reference#unsigned')"><v-icon small color="grey" class="mb-1">mdi-link-variant</v-icon></v-btn></h1>
  <span>If you want to use the <b>/unsigned</b> command or the unsigned keyword with an announcement to query or message members that have not signed up to one of your events yet, the bot might show you an empty list.
    This is because the bot cross-references only members in your server with at least one raider role, as to not trash the results with random members.
    You can define raider roles with the <b>/set raider_roles</b> command or on the dashboard under settings.
  </span>

      <h1 class="mb-5 mt-10" id="temprole">Temporary role <v-btn elevation="0" class="mx-n2" :ripple="false" x-small text plain @click="copyText('https://raid-helper.dev/documentation/reference#temprole')"><v-icon small color="grey" class="mb-1">mdi-link-variant</v-icon></v-btn></h1>
  <span>The temporary role is a premium feature that allows you to assign a discord role to signed up members of an event. You can either enter an existing roles name, a non-existing roles name so that the bot creates the role, or you can enter specific shortcodes for the bot to dynamically name the temporary role. The roles color will be inherited from the events color, unless the role already exists.
  </span>
    <v-simple-table class="mt-5" dark style="background-color: #18191c; color: darkgrey; border: 1px solid black; border-radius: 3px;">
    <template>
      <tbody>
        <tr style="background-color: #1e1f22; color: white;"><td style="height: 35px !important; color: white;"> INPUT </td><td style="height: 35px !important;">DESCRIPTION</td></tr>
        <tr style="background-color: #121315;"><td>id</td><td>The role will be named after the events id. Example: <span style="background-color: #ffffff14; padding: 2px; border-radius: 3px; color: purple;">@924754967951200277</span></td></tr>
        <tr style="background-color: #18191c"><td>title</td><td>The role will be named after the events title. Example: <span style="background-color: #ffffff14; padding: 2px; border-radius: 3px; color: yellow;">@Wednesday Raid</span></td></tr>
        <tr style="background-color: #121315;"><td>date</td><td>The role will be named after the events date. Example: <span style="background-color: #ffffff14; padding: 2px; border-radius: 3px; color: green;">@24-December-2022</span></td></tr>
        <tr style="background-color: #18191c"><td>titledate</td><td>The role will be named after the events title and date. Example: <span style="background-color: #ffffff14; padding: 2px; border-radius: 3px; color: lightblue;">@Wednesday Raid 24-December-2022</span></td></tr>
        <tr style="background-color: #121315;"><td>time</td><td>The role will be named after the events time. Example: <span style="background-color: #ffffff14; padding: 2px; border-radius: 3px; color: red;">@19:45</span></td></tr>
        <tr style="background-color: #18191c;"><td>titletime</td><td>The role will be named after the events title and time. Example: <span style="background-color: #ffffff14; padding: 2px; border-radius: 3px; color: pink;">@Wednesday Raid 19:45</span></td></tr>
        <tr style="background-color: #121315;"><td>titledatetime</td><td>The role will be named after the title, date and time. Example: <span style="background-color: #ffffff14; padding: 2px; border-radius: 3px; color: orange;">@Wednesday Raid 24-December-2022 19:45</span></td></tr>
   </tbody>
    </template>
  </v-simple-table>

    <h1 class="mt-10 mb-5" id="emotes">Emotes <v-btn elevation="0" class="mx-n2" :ripple="false" x-small text plain @click="copyText('https://raid-helper.dev/documentation/reference#emotes')"><v-icon small color="grey" class="mb-1">mdi-link-variant</v-icon></v-btn></h1>
  <span>If you need to use one of the Raid-Helper emotes, you will find that they aren't available to you because they are uploaded on private emote servers specifically meant for the bot. You can either download an emote and then re-upload it yourself, or you can use the ID of the emote directly if you want to use it to set up a custom template. Note that if you upload it yourself with the intention of using it for a custom template, you need to upload it in the server where you want to use the template or in another server where the bot is also a member. It works similar to discord nitro, where you as well as the bot have to be in an emotes server to be able to use it.
  </span>
  <v-expansion-panels class="mt-3">
    <v-expansion-panel class="mt-2" v-for="(item, k) in emoteList" :key="k">
      <v-expansion-panel-header hide-actions color="#18191c" style="color: darkgrey; border-radius: 0px;" class="pa-0">
          <v-avatar tile max-width="25" max-height="25">
        <v-img max-width="25" height="25" :src="'https://cdn.discordapp.com/emojis/' + item.icon + '.png'"></v-img>
          </v-avatar>
          {{item.category}}
      </v-expansion-panel-header>
      <v-expansion-panel-content color="accent">
      <v-row>
        <v-col cols="3" class="px-0">
          <v-simple-table dense class="mt-3 pt-1" dark style="background-color: #121315; color: darkgrey; border-top-right-radius: 0px;">
            <template>
              <tbody>
                <tr style="background-color: #121315;" v-for="(emote, i) in item.emotes" :key="i" class="px-n5"><td><a style="color: grey; text-decoration: none;" :href="'https://cdn.discordapp.com/emojis/' + emote.id + '.png'" target="blank_"><v-avatar class="mt-n1 ml-n4" tile max-width="20" max-height="20"><v-img max-width="20" max-height="20" :src="'https://cdn.discordapp.com/emojis/' + emote.id + '.png'"></v-img></v-avatar>{{emote.name}}</a></td></tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>

        <v-col cols="9" class="px-0">
          <v-simple-table dense class="mt-3 pt-1" dark style="background-color: #121315; color: darkgrey; border-top-left-radius: 0px;">
            <template>
              <tbody>
                <tr style="background-color: #121315;" v-for="(emote, j) in item.emotes" :key="j"><td><span @click="copyText(emote.id)" style="cursor: pointer;">{{emote.id}}</span></td></tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>

  </v-card-text>
  </v-card>

                <v-dialog transition="slide-y-transition" v-model="overlay" overlay-color="black" overlay-opacity="0.6" content-class="elevation-0" max-width="600" dark>
                    <v-card color="#3b3e45" style="border: 1px solid #2c2f33;">
                      <v-card-title>Date & Time</v-card-title>
                      <VueCtkDateTimePicker :first-day-of-week="1" max-height="7" inline no-keyboard label="Date & Time" style="z-index: 3;" id="datepicker1" dark noHeader no-button v-model="date" format="YYYY-MM-DD HH:mm"/>
                        <v-container>
                          <v-row style="background-color: #2f3136;">
                              <v-col align="end">
                            <v-btn elevation="0" @click="overlay = false;" class="mr-2 ma-1" :ripple="false" color="green">OK</v-btn>
                   
                              </v-col>
                          </v-row>
                        </v-container>
                    </v-card>
                </v-dialog>

        		<v-snackbar elevation="0" color="green" v-model="snackbar" timeout="1000" ><span style="font-size:15px;">Copied to clipboard!</span></v-snackbar>
</v-container>
</template>
<script>


export default {
  data() {
    return {
      snackbar: false,
      date: undefined,
      overlay: false,
      openDiscordTimestamps: false,
      openFormatList: false,
      overlayShadow: false,
      emoteList: [
        {
          category: "General",
          icon: "831430831809626142",
          emotes: [
            {name: "Leader", id: "1124529969926779050"},
            {name: "SignUps", id: "1124529971428339752"},
            {name: "SignUps", id: "593930418932285440"},
            {name: "Date", id: "1124529967611523272"},
            {name: "Date", id: "593930359985405983"},
            {name: "Time", id: "1124529972883767398"},
            {name: "Time", id: "593930235658108939"},
            {name: "Countdown", id: "1124530049329139772"},
            {name: "Countdown", id: "858794526176444467"},

            {name: "Tank", id: "878310168289505301"}, 
            {name: "Dps", id: "592440132129521664"}, 
            {name: "Melee", id: "734439523328720913"}, 
            {name: "Ranged", id: "592446395596931072"}, 
            {name: "Mage", id: "898001609735426118"}, 
            {name: "Artillery", id: "898009055031877672"}, 
            {name: "Healer", id: "898011741735235645"}, 
            {name: "Support", id: "878310168344035338"}, 
            {name: "Yes", id: "596014739398721536"}, 
            {name: "No", id: "596014739411173386"}, 
            {name: "Special", id: "606127767528144917"}, 
            {name: "Black", id: "606120236479021062"}, 
            {name: "White", id: "606120236743262238"}, 
            {name: "Red", id: "606120236646662154"}, 
            {name: "Blue", id: "606120236948783113"}, 
            {name: "Yellow", id: "606120437692497930"}, 
            {name: "Pink", id: "606120236613369856"}, 
            {name: "Green", id: "606120236584009728"}, 
            {name: "Grey", id: "606120236311379975"}, 
            {name: "Accepted", id: "831430831809626142"}, 
            {name: "Maybe", id: "831430900113866784"}, 
            {name: "Declined", id: "831430856405024798"}, 
            {name: "Late", id: "612373443551297689"}, 
            {name: "Bench", id: "612373441051361353"}, 
            {name: "Tentative", id: "676284492754976788"}, 
            {name: "Absence", id: "612343589070045200"}, 
            {name: "A_", id: "675573195029479424"}, 
            {name: "B_", id: "675573195138662420"}, 
            {name: "C_", id: "675573195100782593"}, 
            {name: "D_", id: "675573194890936341"}, 
            {name: "E_", id: "675573195243388930"}, 
            {name: "F_", id: "675573195465555979"}, 
            {name: "G_", id: "675573195553636352"}, 
            {name: "H_", id: "675573195365154853"}, 
            {name: "I_", id: "675573195008507916"}, 
            {name: "J_", id: "675573195402641409"}, 
            {name: "K_", id: "675573195352440843"}, 
            {name: "L_", id: "675573195704631296"}, 
            {name: "M_", id: "675573195826397195"}, 
            {name: "N_", id: "675573195796906005"}, 
            {name: "O_", id: "675573195885248512"}, 
            {name: "P_", id: "675573195797037057"}, 
            {name: "Q_", id: "675573196124192770"}, 
            {name: "R_", id: "675573195859820555"}, 
            {name: "S_", id: "675573196396691496"}, 
            {name: "T_", id: "675573195436326923"}, 
            {name: "U_", id: "675573195486789643"}, 
            {name: "V_", id: "675573195797168171"}, 
            {name: "W_", id: "675573196128256003"}, 
            {name: "X_", id: "675573195889180686"}, 
            {name: "Y_", id: "675573196191432725"}, 
            {name: "Z_", id: "675573196640092160"}, 
            {name: "0_", id: "675578304731807754"}, 
            {name: "1_", id: "675578304593657856"}, 
            {name: "2_", id: "675578304518029331"}, 
            {name: "3_", id: "675578305008762880"}, 
            {name: "4_", id: "675578305101168690"}, 
            {name: "5_", id: "675578305004699725"}, 
            {name: "6_", id: "675578305025671189"}, 
            {name: "7_", id: "675578304912424990"}, 
            {name: "8_", id: "675578305000505372"}, 
            {name: "9_", id: "675578304786595841"},

            {name: "black", id: "770983654797213696" }, 
            {name: "darkbrown", id: "770983654671122463" }, 
            {name: "brown", id: "770983654473465877" }, 
            {name: "darkred", id: "770983655349944320" }, 
            {name: "darkorange", id: "770983655258325032" }, 
            {name: "darkgreen", id: "770983654881099817" }, 
            {name: "darkaqua", id: "770983654847414282" }, 
            {name: "aqua", id: "770983654960136283" }, 
            {name: "lightgrey", id: "770983655014268949" }, 
            {name: "grey", id: "770983655224901682" }, 
            {name: "darkgrey", id: "770983655236829194" }, 
            {name: "darkergrey", id: "770983654880837642" }, 
            {name: "darknavy", id: "770983655290961940" }, 
            {name: "navy", id: "770983655325302784" }, 
            {name: "darkpurple", id: "770983655270645770" }, 
            {name: "blue", id: "770983654968262696" }, 
            {name: "darkblue", id: "796425294830501959" }, 
            {name: "lightblue", id: "770983655332904980" }, 
            {name: "lighterblue", id: "770986603828084757" }, 
            {name: "purple", id: "770983655526105088" }, 
            {name: "green", id: "770983655190822913" }, 
            {name: "red", id: "770983655241154591" }, 
            {name: "darkpink", id: "770983655287291914" }, 
            {name: "pink", id: "770983655308263464" }, 
            {name: "gold", id: "770983655224639488" }, 
            {name: "darkgold", id: "770983654939820052" }, 
            {name: "lightgreen", id: "770983655244824596" }, 
            {name: "orange", id: "770983655102873601" }, 
            {name: "yellow", id: "770983655187283970" }, 
            {name: "lightyellow", id: "770983655521648660" },
          ]
        },
        {
          category: "World of Warcraft",
          icon: "599020379125841954",
          emotes: [ 
            {name: "Warrior", id: "579532030153588739"}, 
            {name: "Druid", id: "579532029675438081"}, 
            {name: "Paladin", id: "579532029906124840"}, 
            {name: "Rogue", id: "579532030086217748"}, 
            {name: "Hunter", id: "579532029880827924"}, 
            {name: "Mage", id: "579532030161977355"}, 
            {name: "Warlock", id: "579532029851336716"}, 
            {name: "Priest", id: "579532029901799437"}, 
            {name: "Shaman", id: "579532030056857600"}, 
            {name: "Deathknight", id: "599012538935410701"}, 
            {name: "Demonhunter", id: "599012539015364633"}, 
            {name: "Monk", id: "599012539556167691"}, 
            {name: "Evoker", id: "1013161650184003744"}, 
            {name: "Frost", id: "637564231469891594"}, 
            {name: "Fire", id: "637564231239073802"}, 
            {name: "Arcane", id: "637564231545389056"}, 
            {name: "Assassination", id: "637564351707873324"}, 
            {name: "Combat", id: "637564352333086720"}, 
            {name: "Subtlety", id: "637564352169508892"}, 
            {name: "Protection", id: "637564444834136065"}, 
            {name: "Fury", id: "637564445215948810"}, 
            {name: "Arms", id: "637564445031399474"}, 
            {name: "Discipline", id: "637564323442720768"}, 
            {name: "Holy", id: "637564323530539019"}, 
            {name: "Shadow", id: "637564323291725825"}, 
            {name: "Affliction", id: "637564406984867861"}, 
            {name: "Demonology", id: "637564407001513984"}, 
            {name: "Destruction", id: "637564406682877964"}, 
            {name: "Beastmastery", id: "637564202021814277"}, 
            {name: "Marksman", id: "637564202084466708"}, 
            {name: "Survival", id: "637564202130866186"}, 
            {name: "Holy1", id: "637564297622454272"}, 
            {name: "Retribution", id: "637564297953673216"}, 
            {name: "Protection1", id: "637564297647489034"}, 
            {name: "Blood", id: "637564101274632192"}, 
            {name: "Frost1", id: "637564101262049280"}, 
            {name: "Unholy", id: "637564101329027082"}, 
            {name: "Havoc", id: "637564138964516867"}, 
            {name: "Vengeance", id: "637564139371233290"}, 
            {name: "Restoration", id: "637564172007112723"}, 
            {name: "Feral", id: "637564172061900820"}, 
            {name: "Balance", id: "637564171994529798"}, 
            {name: "Guardian", id: "637564171696734209"}, 
            {name: "Elemental", id: "637564379595931649"}, 
            {name: "Restoration1", id: "637564379847458846"}, 
            {name: "Brewmaster", id: "637564262167871489"}, 
            {name: "Windwalker", id: "637564262054625281"}, 
            {name: "Mistweaver", id: "637564262289637433"}, 
            {name: "Enhancement", id: "637564379772223489"}, 
            {name: "Outlaw", id: "794267634497486858"}, 
            {name: "Smite", id: "887257034066653184"}, 
            {name: "Devastation", id: "1013161648728592444"}, 
            {name: "Preservation", id: "1013161651706544158"},
            {name: "Augmentation", id: "1127164727328510054"},
            {name: "Tailoring", id: "641419370442129429"},
            {name: "Blacksmithing", id: "641419369678635029"},
            {name: "Engineering", id: "641419369750069312"},
            {name: "Alchemy", id: "641419369989275648"},
            {name: "Leatherworking", id: "641419370198990858"},
            {name: "Enchanting", id: "641419370106716170"},
            {name: "Jewelcrafting", id: "779033915448885338"},
            {name: "Inscription", id: "779033915129987082"},
            {name: "Herbalism", id: "641419370437935104"},
            {name: "Skinning", id: "641419370802970644"},
            {name: "Mining", id: "641419370471358477"},
            {name: "Fishing", id: "779033915284783134"},
            {name: "Cooking", id: "779034208949370910"},
            {name: "Skull", id: "1118218142729130034"},
            {name: "Cross", id: "1118218134290178098"},
            {name: "Star", id: "1118218148294950983"},
            {name: "Circle", id: "1118218132734095482"},
            {name: "Diamond", id: "1118218138631274566"},
            {name: "Triangle", id: "1118218150392123432"},
            {name: "Square", id: "1118218145623179284"},
            {name: "Moon", id: "1118218140946550835"},
          ]
        },
        {
          category: "FFXIV",
          icon: "600228478297571328",
          emotes: [
            {name: "Tank", id: "823967222778298389"}, {name: "Melee", id: "823967222811852830"}, {name: "Ranged", id: "823967222677504091"}, {name: "Magical", id: "823967222874636298"}, {name: "Healer", id: "823967225270501376"}, {name: "Dps", id: "823965472299024505"}, {name: "Allrounder", id: "869859911163605012"}, {name: "Whitemage", id: "600116580533141516"}, {name: "WarriorFF", id: "600116580873142302"}, {name: "Summoner", id: "600116580915085323"}, {name: "Scholar", id: "600116580562501635"}, {name: "Samurai", id: "600116580797644830"}, {name: "Redmage", id: "600116580667359244"}, {name: "PaladinFF", id: "600116580533272675"}, {name: "Ninja", id: "600116580759765012"}, {name: "MonkFF", id: "600116580688330769"}, {name: "Machinist", id: "600116580784799754"}, {name: "Gunbreaker", id: "600116580738924544"}, {name: "Dragoon", id: "600116580474683417"}, {name: "Darkknight", id: "600116580621221888"}, {name: "Dancer", id: "600116580646387728"}, {name: "Blackmage", id: "600116580629872650"}, {name: "Bard", id: "600116580633935873"}, {name: "Astrologian", id: "600116580575346688"}, {name: "Bluemage", id: "823973093843140688"}, {name: "Reaper", id: "918466136151040000"}, {name: "Sage", id: "1215292847184547873"},
          ]
        },
        {
          category: "Guild Wars 2",
          icon: "686307981549502508",
          emotes: [   
            {name: "Bannerslave", id: "686325288694579230"}, 
            {name: "Guardian", id: "1308086252930596915"}, 
            {name: "Dragonhunter", id: "1308084438403649641"}, 
            {name: "Firebrand", id: "1308084445319790663"}, 
            {name: "Willbender", id: "1308086237290172426"}, 
            {name: "Revenant", id: "1308086244806365248"}, 
            {name: "Herald", id: "1308086306521485342"}, 
            {name: "Renegade", id: "1308084466534584424"}, 
            {name: "Vindicator", id: "1308084487103447126"}, 
            {name: "Warrior", id: "1308084492162039858"}, 
            {name: "Berserker", id: "1308084427850649661"}, 
            {name: "Spellbreaker", id: "1308086241543323678"}, 
            {name: "Bladesworn", id: "1308084429855522968"}, 
            {name: "Engineer", id: "1308084443877212171"}, 
            {name: "Scrapper", id: "1308084473069436959"}, 
            {name: "Holosmith", id: "1308084453670916096"}, 
            {name: "Mechanist", id: "1308086249717764177"}, 
            {name: "Ranger", id: "1308084462864695397"}, 
            {name: "Druid", id: "1308084440450203708"}, 
            {name: "Soulbeast", id: "1308086243057205269"}, 
            {name: "Untamed", id: "1308086240037306440"}, 
            {name: "Thief", id: "1308084484062707754"}, 
            {name: "Daredevil", id: "1308084435765297272"}, 
            {name: "Deadeye", id: "1308084437367394314"}, 
            {name: "Specter", id: "1308084476974202910"}, 
            {name: "Elementalist", id: "1308084442618920970"}, 
            {name: "Tempest", id: "1308084481122631791"}, 
            {name: "Weaver", id: "1308084494892404797"}, 
            {name: "Catalyst", id: "1308084431675850762"}, 
            {name: "Mesmer", id: "1308084457030287400"}, 
            {name: "Chronomancer", id: "1308084433571676160"}, 
            {name: "Mirage", id: "1308086248291827802"}, 
            {name: "Virtuoso", id: "1308086238628286555"}, 
            {name: "Necromancer", id: "1308084460519948399"}, 
            {name: "Reaper", id: "1308086247104708678"}, 
            {name: "Scourge", id: "1308084469743226975"}, 
            {name: "Harbinger", id: "1308084449203720223"},
          ]
        },
        {
          category: "The Elder Scrolls Online",
          icon: "683822339431071756",
          emotes: [    
          {name: "Tank", id: "878310168289505301"},
            {name: "Stamina", id: "904494097425911848"}, 
            {name: "Magicka", id: "904494123527069789"}, 
            {name: "Healer", id: "898011741735235645"},
            {name: "dk_tank", id: "684464432558243852"}, 
            {name: "dk_stamina", id: "684464431853600777"}, 
            {name: "dk_magicka", id: "684464432063053829"}, 
            {name: "dk_healer", id: "684464432046407684"}, 
            {name: "nb_tank", id: "684464395081875517"}, 
            {name: "nb_stamina", id: "684464394922754109"}, 
            {name: "nb_magicka", id: "684464394943725568"}, 
            {name: "nb_healer", id: "684464395006509056"}, 
            {name: "necro_tank", id: "684464415147556867"}, 
            {name: "necro_stamina", id: "684464414862475269"},
             {name: "necro_magicka", id: "684464415147556953"}, 
             {name: "necro_healer", id: "684464414774263817"}, 
             {name: "sorc_tank", id: "684464373753708592"}, 
             {name: "sorc_stamina", id: "684464373598912541"}, 
             {name: "sorc_magicka", id: "684464373342666789"}, 
             {name: "sorc_healer", id: "684464373414101033"}, 
             {name: "templar_tank", id: "684464333979516928"}, 
             {name: "templar_stamina", id: "684464333526269954"}, 
             {name: "templar_magicka", id: "684464333870334005"}, 
             {name: "templar_healer", id: "684464333685522446"}, 
             {name: "warden_tank", id: "684464355370205235"}, 
             {name: "warden_stamina", id: "684464355265609767"}, 
             {name: "warden_magicka", id: "684464355336781827"}, 
             {name: "warden_healer", id: "684464354967552044"},
             {name: "arcanist_tank", id: "1107252805162508298"},
             {name: "arcanist_stamina", id: "1107252802499125379"},
             {name: "arcanist_magicka", id: "1107252800833982485"},
             {name: "arcanist_healer", id: "1107252797977673809"},
             {name: "Tank", id: "1117163858952458341"},
             {name: "Stamina", id: "1117163857589325964"},
             {name: "Magicka", id: "1117163855244697620"},
             {name: "Healer", id: "1117163853755723829"},
             {name: "Dragonknight_Tank", id: "1117081113576353883"},
             {name: "Dragonknight_Stamina", id: "1117081569413300307"},
             {name: "Dragonknight_Magicka", id: "1117081983030394941"},
             {name: "Dragonknight_Heal", id: "1117084172645830736"},
             {name: "Nightblade_Tank", id: "1117081116499775488"},
             {name: "Nightblade_Stamina", id: "1117081574400327680"},
             {name: "Nightblade_Magicka", id: "1117081986847232112"},
             {name: "Nightblade_Heal", id: "1117084175166615552"},
             {name: "Necromancer_Tank", id: "1117081118953451591"},
             {name: "Necromancer_Stamina", id: "1117081577571233912"},
             {name: "Necromancer_Magicka", id: "1117081990747922542"},
             {name: "Necromancer_Heal", id: "1117084176986939503"},
             {name: "Sorcerer_Tank", id: "1117081120706674688"},
             {name: "Sorcerer_Stamina", id: "1117081581216071690"},
             {name: "Sorcerer_Magicka", id: "1117081993423900732"},
             {name: "Sorcerer_Heal", id: "1117084179763568670"},
             {name: "Templar_Tank", id: "1117081122472464444"},
             {name: "Templar_Stamina", id: "1117081585922097212"},
             {name: "Templar_Magicka", id: "1117081996867420190"},
             {name: "Templar_Heal", id: "1117084182712176650"},
             {name: "Warden_Tank", id: "1117081126431887451"},
             {name: "Warden_Stamina", id: "1117081596370092042"},
             {name: "Warden_Magicka", id: "1117081999761481758"},
             {name: "Warden_Heal", id: "1117084473218060379"},
             {name: "Arcanist_Tank", id: "1117081111454044211"},
             {name: "Arcanist_Stamina", id: "1117081565957201950"},
             {name: "Arcanist_Magicka", id: "1117081981105217667"},
             {name: "Arcanist_Heal", id: "1117084170884239423"},
          ]
        },
        {
          category: "New World",
          icon: "874723441675206696",
          emotes: [ 
            {name: "Bow", id: "878762627759751239" }, {name: "Fire_Staff", id: "878761203910995968" }, {name: "Great_Axe", id: "878760347635449858" }, {name: "Greatsword", id: "1032793636217290802" }, {name: "Hatchet", id: "878761204078764093" }, {name: "Ice_Gauntlet", id: "878760348138741830" }, {name: "Life_Staff", id: "878760347954196501" }, {name: "Musket", id: "878760348071628824" }, {name: "Rapier", id: "878760348214243348" }, {name: "Spear", id: "878760348285566996" }, {name: "Sword", id: "878760348071637033" }, {name: "War_Hammer", id: "878760348419780678" }, {name: "Void_Gauntlet", id: "911091628238864394" }, {name: "Blunderbuss", id: "961578908283711498"}, {name: "Bow", id: "878411067435417631" }, {name: "Fire_Staff", id: "878411929050312734" }, {name: "Great_Axe", id: "878411928815415317" }, {name: "Greatsword", id: "1032793634518601829" }, {name: "Hatchet", id: "878411929020948531" }, {name: "Ice_Gauntlet", id: "878411929280978995" }, {name: "Life_Staff", id: "878411928916090941" }, {name: "Musket", id: "878411929465548890" }, {name: "Rapier", id: "878411929192915026" }, {name: "Spear", id: "878411929251643452" }, {name: "Sword", id: "878411929205501982" }, {name: "War_Hammer", id: "878411929364873216" }, {name: "Void_Gauntlet", id: "911091627915882548" }, {name: "Blunderbuss", id: "968452881810325566"},
          ]
        },
        {
          category: "Lost Ark",
          icon: "877979009038827591",
          emotes: [ 
            {name: "Warrior", id: "877965853491101740"}, 
            {name: "Martial_Artist", id: "877966126158585886"}, 
            {name: "Assassin", id: "877966848556163122"}, 
            {name: "Gunner", id: "877966848652623922"}, 
            {name: "Mage", id: "877966520586752030"}, 
            {name: "Specialist", id: "936456800126009375"}, 
            {name: "Berserker", id: "877969260016730114"}, 
            {name: "Paladin", id: "877969258263511070"}, 
            {name: "Gunlancer", id: "877969260402606080"}, 
            {name: "Destroyer", id: "936456800067272714"}, 
            {name: "Striker", id: "877969258179596308"}, 
            {name: "Wardancer", id: "877969260100616273"}, 
            {name: "Scrapper", id: "877969260285157376"}, 
            {name: "Soulfist", id: "877969259337232414"}, 
            {name: "Glaivier", id: "936456799949824065"}, 
            {name: "Gunslinger", id: "877969257709846580"}, 
            {name: "Artillerist", id: "877969258364157963"}, 
            {name: "Deadeye", id: "877969260444524584"}, 
            {name: "Sharpshooter", id: "877969259261747262"}, 
            {name: "Scouter", id: "936456799740104715"}, 
            {name: "Bard", id: "877969258846490655"}, 
            {name: "Summoner", id: "877969259685380237"}, 
            {name: "Sorceress", id: "921078644238057592"}, 
            {name: "Arcana", id: "936456799756910633"}, 
            {name: "Shadowhunter", id: "877969259706339358"}, 
            {name: "Deathblade", id: "877989308865318952"}, 
            {name: "Reaper", id: "936456800218255450"}, 
            {name: "Artist", id: "936456800067264552"},
            {name: "Slayer", id: "1107246499152265216"},
            {name: "Breaker", id: "1217511042414805247"},
            {name: "Souleater", id: "1182758568840134718"},
            {name: "Lance_Master", id: "936456799949824065"},
            {name: "Aeromancer", id: "1128971197401530439"},
            {name: "Wildsoul", id: "1346554405863952495"},
            {name: "Slayer", id: "1107246499152265216"}
          ]
        },
        {
          category: "Star Wars: The Old Republic",
          icon: "794787500945571851",
          emotes: [     
            {name: "Guardian", id: "794727893682618368"}, {name: "Powertech", id: "794727893988540437"}, {name: "Gunslinger", id: "794727893514977281"}, {name: "Assassin", id: "794727893284552775"}, {name: "Shadow1", id: "794728069834735636"}, {name: "Scoundrel", id: "794728069168234527"}, {name: "Sage", id: "794728069327618059"}, {name: "Sorcerer", id: "794728069801181254"}, {name: "Operative", id: "794727893854715905"}, {name: "Sniper", id: "794728069755437076"}, {name: "Vanguard", id: "794728277549514752"}, {name: "Juggernaut", id: "794727893854453820"}, {name: "Sentinel", id: "794728069561581578"}, {name: "Commando", id: "794727893686157352"}, {name: "Mercenary", id: "794727893783674881"}, {name: "Marauder", id: "794727893627568129"},
          ]
        },
        {
          category: "League of Legends",
          icon: "796548085475311617",
          emotes: [      
            {name: "Top", id: "796543277129269261"}, {name: "Jungle", id: "796543218732892215"}, {name: "Mid", id: "796543218169675787"}, {name: "Bot", id: "796543218900271104"}, {name: "Support", id: "796543219269369868"}, {name: "Fill", id: "796543219105660948"}, {name: "Spectator", id: "796546490972766268"},
          ]
        },
        {
          category: "Swords of Legends Online",
          icon: "869099081862086667",
          emotes: [
            {name: "Spellsword", id: "869096123321704508"}, {name: "Reaper", id: "869096122981969970"}, {name: "Bard", id: "869096121434267648"}, {name: "Summoner", id: "869096123262967848"}, {name: "Berserker", id: "869096123078426644"}, {name: "Spearmaster", id: "869096123313319936"}, {name: "Sword_Artist", id: "869096123418169364"}, {name: "Bladestorm", id: "869096123405582408"}, {name: "Assassin", id: "869096124307345448"}, {name: "Occultist", id: "869096124038926346"}, {name: "Dissonance", id: "869096122851930142"}, {name: "Harmony", id: "869096123032293418"}, {name: "Natures_Wrath", id: "869096123833385000"}, {name: "Nuwas_Blessing", id: "869096123791446017"}, {name: "Slayer", id: "869096123174879242"}, {name: "Drunken_Master", id: "869096123309105173"}, {name: "General", id: "869096123351052318"}, {name: "Phalanx", id: "869096124005363743"},          ]
        },
        {
          category: "Dark Age of Camelot",
          icon: "878305940858892348",
          emotes: [  
            {name: "Animist", id: "878295806891925504" }, {name: "Armsman", id: "878295806837411900" }, {name: "Bainshee", id: "878295806946476072" }, {name: "Bard", id: "878295807059718174" }, {name: "Berserker", id: "878295806862561381" }, {name: "Blademaster", id: "878295806862585927" }, {name: "Bonedancer", id: "878295806984196126" }, {name: "Cabalist", id: "878295806908702771" }, {name: "Champion", id: "878295806908702801" }, {name: "Cleric", id: "878295806719963187" }, {name: "Druid", id: "878295806954848286" }, {name: "Eldritch", id: "878295806615105617" }, {name: "Enchanter", id: "878295806954831872" }, {name: "Friar", id: "878295806753513473" }, {name: "Healer", id: "878295806954848346" }, {name: "Heretic", id: "878295807051333682" }, {name: "Hero", id: "878295807151972442" }, {name: "Hunter", id: "878295807042928680" }, {name: "Infiltrator", id: "878295807042920488" }, {name: "Mauler", id: "878295807030341722" }, {name: "Mentalist", id: "878295807135207425" }, {name: "Mercenary", id: "878295806824833065" }, {name: "Minstrel", id: "878295807114219621" }, {name: "Necromancer", id: "878295807172952114" }, {name: "Nightshade", id: "878295807110045736" }, {name: "Paladin", id: "878295807189737512" }, {name: "Ranger", id: "878295806799642715" }, {name: "Reaver", id: "878295807168770058" }, {name: "Runemaster", id: "878295807156183050" }, {name: "Savage", id: "878295807240056843" }, {name: "Scout", id: "878295807202328627" }, {name: "Shadowblade", id: "878295806971613255" }, {name: "Shaman", id: "878295807210704956" }, {name: "Skald", id: "878295807328125018" }, {name: "Sorcerer", id: "878295806967435296" }, {name: "Spiritmaster", id: "878295807311351858" }, {name: "Thane", id: "878295806929686539" }, {name: "Theurgist", id: "878295807328133181" }, {name: "Valewalker", id: "878295807277797406" }, {name: "Valkyrie", id: "878295807361683456" }, {name: "Vampiir", id: "878295807026159709" }, {name: "Warden", id: "878295807298764891" }, {name: "Warlock", id: "878295807302975578" }, {name: "Warrior", id: "878295807466569738" }, {name: "Wizard", id: "878295807017779241" },
          ]
        },
        {
          category: "Lord of the Rings Online",
          icon: "796586962785533962",
          emotes: [       
            {name: "Beorning", id: "796583829778595890"}, {name: "Brawler", id: "898417226540011560"}, {name: "Burglar", id: "796583830512205834"}, {name: "Captain", id: "796583831019847690"}, {name: "Champion", id: "796583830433562641"}, {name: "Guardian2", id: "796583831087218758"}, {name: "Hunter1", id: "796583830994812968"}, {name: "LoreMaster", id: "796583830936485949"}, {name: "Minstrel", id: "796583831016177766"}, {name: "RuneKeeper", id: "796583831124574277"}, {name: "Warden", id: "796583830982754305"},
          ]
        },
        {
          category: "Destiny 2",
          icon: "642732722653102080",
          emotes: [        
            {name: "Titan", id: "814712823899881484"}, {name: "Hunter", id: "814712823862001684"}, {name: "Warlock", id: "814712824009588746"},          
          ]
        },
        {
          category: "Albion Online",
          icon: "1082659659149738085",
          emotes: [        
            {name: "Tank", id: "1082580403497472000"},  
            {name: "DPS", id: "1082580437278412831"},  
            {name: "Heal", id: "1082580490986475600"},  
            {name: "Support", id: "1082580466051317840"},  
            {name: "Battle_Mount", id: "1082710510115491920"},

            {name: "Hammer", id: "1082585414226956389"},  
            {name: "Hammer", id: "1082639825762521158"},  
            {name: "Great Hammer", id: "1082639817009016852"},  
            {name: "Forge Hammers", id: "1082639806670057533"},  
            {name: "Polehammer", id: "1082639819605291008"},  
            {name: "Tombhammer", id: "1082639813313822745"},  
            {name: "Grovekeeper", id: "1082639822671335464"},  
            {name: "Hand of Justice", id: "1082639810629488721"}, 

            {name: "Mace", id: "1082585396526989432"},  
            {name: "Mace", id: "1082639891831201842"},  
            {name: "Heavy Mace", id: "1082639882414985248"},  
            {name: "Bedrock Mace", id: "1082639896080023582"},  
            {name: "Camlann Mace", id: "1082639879734829067"},  
            {name: "Incubus Mace", id: "1082639887381053500"},
            {name: "Oathkeepers", id: "1082639871136509994"},  
            {name: "Morning Star", id: "1082639876220006470"},  

            {name: "Quarterstaff", id: "1082585401505628180"},  
            {name: "Quarterstaff", id: "1082639952476647506"},  
            {name: "Ironclad Staff", id: "1082639945954512947"},  
            {name: "Double Bladed Staff", id: "1082639943383396352"},  
            {name: "Black Monk Stave", id: "1082639940095066253"},  
            {name: "Soulscythe", id: "1082639959720218664"},  
            {name: "Staff of Balance", id: "1082639955718836285"},  
            {name: "Grailseeker", id: "1082639949498691584"},  

            {name: "Nature Staff", id: "1082585381473619978"},  
            {name: "Nature Staff", id: "1082590674773364776"}, 
            {name: "Great Nature Staff", id: "1082590692381040660"},  
            {name: "Wild Staff", id: "1082590690229354506"},  
            {name: "Druidic Staff", id: "1082590686689374312"},  
            {name: "Blight Staff", id: "1082590683589787708"},  
            {name: "Rampant Staff", id: "1082590681052237894"},  
            {name: "Ironroot Staff", id: "1082590677810028566"},  

            {name: "Holy Staff", id: "1082585378093011006"},  
            {name: "Holy Staff", id: "1082585378093011006"},  
            {name: "Great Holy Staff", id: "1082590671929622540"},  
            {name: "Divine Staff", id: "1082590668066672740"},  
            {name: "Lifetouch Staff", id: "1082590664895766628"},  
            {name: "Fallen Staff", id: "1082590661771006066"},  
            {name: "Redemption Staff", id: "1082590659367682129"},  
            {name: "Hallowfall", id: "1082590656268079184"},  

            {name: "Arcane Staff", id: "1082585374884364299"},  
            {name: "Arcane Staff", id: "1082641094900187156"},  
            {name: "Enigmatic Staff", id: "1082641086922620938"},  
            {name: "Great Arcane Staff", id: "1082641080585031711"}, 
            {name: "Witchwork Staff", id: "1082641091037237248"},  
            {name: "Occult Staff", id: "1082641077523198083"},  
            {name: "Malevolent Locus", id: "1082641083466518618"},  
            {name: "Evensong", id: "1082641070023778324"},  

            {name: "Cursed Staff", id: "1082585391661592646"},  
            {name: "Cursed Staff", id: "1082641135501053962"},
            {name: "Demonic Staff", id: "1082641123249500191"},  
            {name: "Great Cursed Staff", id: "1082641120019882014"},  
            {name: "Lifecurse Staff", id: "1082641133093539861"},  
            {name: "Cursed Skull", id: "1082641126458138734"},
            {name: "Damnation Staff", id: "1082641113770373140"},  
            {name: "Shadowcaller", id: "1082641130233012294"},  

            {name: "Wargloves", id: "1082585393825857616"},  
            {name: "Brawler Gloves", id: "1082598440237797388"},  
            {name: "Battle Bracers", id: "1082598437456982066"},  
            {name: "Spiked Gauntlets", id: "1082598434319642664"},  
            {name: "Ursine Maulers", id: "1082598431568171060"},  
            {name: "Hellfire Hands", id: "1082598428527317082"},  
            {name: "Ravenstrike Cestus", id: "1082598426581143572"}, 
            {name: "Fists of Avalon", id: "1082598423489949777"},  

            {name: "Axe", id: "1082585405272109107"},  
            {name: "Greataxe", id: "1082639683156201492"},  
            {name: "Battleaxe", id: "1082639701015531651"},
            {name: "Halberd", id: "1082639693004406908"},  
            {name: "Carrioncaller", id: "1082639689762226186"},  
            {name: "Infernal Scythe", id: "1082639697815281745"},
            {name: "Bear Paws", id: "1082639685886681130"},  
            {name: "Realmbreaker", id: "1082639679502942278"},  

            {name: "Sword", id: "1082585398947094569"},  
            {name: "Broadsword", id: "1082640022638968903"},  
            {name: "Claymore", id: "1082640004951593081"},  
            {name: "Dual Swords", id: "1082640015693197322"},  
            {name: "Clarent Blade", id: "1082640018780201031"},  
            {name: "Carving Sword", id: "1082640009435283496"},  
            {name: "Galatine Pair", id: "1082640012874625106"},  
            {name: "Kingmaker", id: "1082640000438501446"},  

            {name: "Crossbow", id: "1082585368303501354"},  
            {name: "Crossbow", id: "1082639746846707822"}, 
            {name: "Light Crossbow", id: "1082639762315288656"},  
            {name: "Heavy Crossbow", id: "1082639753322713201"},  
            {name: "Weeping Repeater", id: "1082639759572213790"},  
            {name: "Boltcasters", id: "1082639756858503178"},  
            {name: "Siegebow", id: "1082639749484916797"},  
            {name: "Energy Shaper", id: "1082639743260561428"},  

            {name: "Bow", id: "1082585372262944829"},  
            {name: "Bow", id: "1082597693089652786"},  
            {name: "Longbow", id: "1082597690413699082"},  
            {name: "Warbow", id: "1082597695207780392"},  
            {name: "Whispering Bow", id: "1082597688140369920"},  
            {name: "Wailing Bow", id: "1082597684914946092"},  
            {name: "Bow of Badon", id: "1082597683002347520"},  
            {name: "Mistpiercer", id: "1082597680028598314"},  

            {name: "Spear", id: "1082585408497528902"},  
            {name: "Spear", id: "1082641297715765288"},  
            {name: "Glaive", id: "1082641277931229234"},  
            {name: "Pike", id: "1082641284101054504"}, 
            {name: "Heron Spear", id: "1082641291373969509"},  
            {name: "Spirithunter", id: "1082641281328611348"},  
            {name: "Trinity Spear", id: "1082641287901089852"},  
            {name: "Daybreaker", id: "1082641294125436979"},  

            {name: "Dagger", id: "1082585410527580180"},  
            {name: "Dagger", id: "1082597675465199656"}, 
            {name: "Claws", id: "1082597678011121765"},  
            {name: "Dagger Pair", id: "1082597672462078012"},  
            {name: "Bloodletter", id: "1082597669702221905"},  
            {name: "Demonfang", id: "1082597666720071700"},  
            {name: "Deathgivers", id: "1082597664983621632"},  
            {name: "Bridled Fury", id: "1082597662186029057"},  

            {name: "Fire Staff", id: "1082585388083838976"},  
            {name: "Fire Staff", id: "1082641203276808213"},  
            {name: "Great Fire Staff", id: "1082641182053642300"},  
            {name: "Infernal Staff", id: "1082641189439811633"},  
            {name: "Wildfire Staff", id: "1082641194288427018"},  
            {name: "Brimstone Staff", id: "1082641178429763654"}, 
            {name: "Blazing Staff", id: "1082641185413279785"},  
            {name: "Dawnsong", id: "1082641172729708586"},  

            {name: "Frost Staff", id: "1082585383759515690"},  
            {name: "Frost Staff", id: "1082641261938364436"},  
            {name: "Great Frost Staff", id: "1082641240769708112"},  
            {name: "Glacial Staff", id: "1082641244460695552"},
            {name: "Hoarfrost Staff", id: "1082641258159288380"},  
            {name: "Icicle", id: "1082641251767177286"},  
            {name: "Permafrost Prism", id: "1082641248160067635"},  
            {name: "Chillhowl", id: "1082641255382646784"},  
          ]
        },
        {
          category: "Tarisland",
          icon: "1250504567678963722",
          emotes: [        
            {name: "Warrior", id: "1250500363216490516"},
            {name: "Paladin", id: "1250500351681888368"},
            {name: "Barbarian", id: "1250500345306808433"},
            {name: "Shadow", id: "1250500360993247292"},
            {name: "Mage", id: "1250500349416968223"},
            {name: "Bard", id: "1250500347412091013"},
            {name: "Priest", id: "1250500355981054002"},
            {name: "Phantom", id: "1250500353691226214"},
            {name: "Ranger", id: "1250500358711541780"},
          ]
        },
        {
          category: "Throne & Liberty",
          icon: "1283209903883812875",
          emotes: [        
            {name: "Sword&Shield", id: "1283217305836454004"},
            {name: "Greatsword", id: "1283217475290267648"},  
            {name: "Daggers", id: "1283217469049147533"},  
            {name: "Staff", id: "1283217492180733992"},  
            {name: "Longbow", id: "1283217483821744179"},  
            {name: "Crossbow", id: "1283217457913532528"},
            {name: "Wand&Tome", id: "1283217315466580071"},

            {name: "Battleweaver", id: "1305473373828284476"},
            {name: "Berserker", id: "1305473374969139220"},
            {name: "Crusader", id: "1305473376122441788"},
            {name: "Darkblighter", id: "1305473377791643658"},
            {name: "Disciple", id: "1305473378936946709"},
            {name: "Fury", id: "1305473380023013406"},
            {name: "Infiltrator", id: "1305473413414129664"},
            {name: "Invocator", id: "1305473414923812914"},
            {name: "Liberator", id: "1305473416073052170"},
            {name: "Outrider", id: "1305473417360834672"},
            {name: "Paladin", id: "1305473419210653706"},
            {name: "Raider", id: "1305473454308327425"},
            {name: "Ranger", id: "1305473455562690592"},
            {name: "Ravager", id: "1305473457370300456"},
            {name: "Scorpion", id: "1305473458347704322"},
            {name: "Scout", id: "1305473460411301938"},
            {name: "Seeker", id: "1305473487858700308"},
            {name: "Sentinel", id: "1305473489519640668"},
            {name: "Spellblade", id: "1305473490685526067"},
            {name: "Templar", id: "1305473491696484394"},
            {name: "Warden", id: "1305473493575401483"},

            {name: "Cavalier", id: "1314320014425198602"},
            {name: "Eradicator", id: "1314320012730830858"},
            {name: "Gladiator", id: "1314320011174608977"},
            {name: "Impaler", id: "1314320017378115714"},
            {name: "Shadowdancer", id: "1314320015670902794"},
            {name: "Steelheart", id: "1314320018644930630"},
            {name: "Voidlance", id: "1314320019907280968"},


          ]
        },
      ]
    }
  },
  methods: {
    copyText(value) {
      navigator.clipboard.writeText(value);
      this.snackbar = true;
    },

    getDate() {
      if (this.date === undefined || this.date === '') {
      return " _____ "
      } else {
      return new Date(this.date.replace(/-/g, "/")).toLocaleDateString([],{ weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
      }
    },

    getTime() {
      if (this.date === undefined || this.date === '') {
      return " _____ "
      } else {
      return new Date(this.date.replace(/-/g, "/")).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
      }
    },

    getUnix() {
      try {
      return new Date(this.date.replace(/-/g, "/")).getTime() / 1000;
      } catch (error) {
        return "";
      }
    }
  },
  created(){
    document.title = "Raid-Helper - Reference"
  },
  mounted() {
      var element = this.$refs[this.$route.hash.replace("#", "")];
      if (element !== undefined && element.offsetTop !== undefined) {
      window.scrollTo(0, element.offsetTop);
      }
  }

  
};
</script>
<style>

.theme--dark.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
     border-bottom: 0px !important;
}
</style>
